define.alias("shared/helpers/word-initials", "preview-grid/helpers/word-initials");